module.exports = __webpack_public_path__ + "img/sample-barcodes.f1500dfc.png";